import randomWords from 'random-words';
import menuImagePlaceholder from '../assets/img/menu-image-placeholder.png';

const randomId = (length = 5) =>
  Math.floor(
    Math.pow(10, length - 1) +
      Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1),
  );
const randomNumber = ({ min, max }) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
};
const randomPrice = ({ min, max }) => {
  const random = Math.random() * (max - min) + min;
  var power = Math.pow(10, 2);
  return Math.floor(random * power) / power;
};

export const createMenuItem = ({ index }) => {
  const payload =
    index === 0
      ? createMenuTextField({ index })
      : index === 1
      ? createMenuSubHeader({ index })
      : createMenuProduct({ index });
  return payload;
};

export const createMenuTextField = ({ index = 0 } = {}) => ({
  selectedSalesAreas: '[]',
  textField: {
    text: randomWords({ exactly: 5, join: ' ' }),
  },
  sortOrder: index,
  itemType: 'textField',
  itemId: index + 1,
});

export const createMenuSubHeader = ({
  index = 0,
  selectedSalesAreas = '',
  sortOrder = index,
  itemType = 'subHeader',
  subHeader = {
    text: randomWords({ exactly: 5, join: ' ' }),
  },
  itemId = index + 1,
} = {}) => ({
  selectedSalesAreas,
  sortOrder,
  itemType,
  subHeader,
  itemId,
});

export const createMenuProduct = ({
  index,
  itemType = 'product',
  selectedSalesAreas = '[]',
  sortOrder = 0,
  itemId = index + 1,
  productId = randomId(11),
  displayName = randomWords({ exactly: 2, join: ' ' }),
  displayRecordId = randomId(6),
  defaultPortionId = 1,
  choices = [],
  showPrices = 1,
  mayStock = 0,
  id = productId,
  name = displayName,
  description = randomWords({ exactly: 15, join: ' ' }),
  effectiveDate = '',
  expiryDate = '',
  image = menuImagePlaceholder,
  keywords = [570, 571, 572, 573, 574],
  eposName = displayName,
  displayRecords = [
    {
      id: randomId(6),
      name,
      description,
      effectiveDate: '',
      expiryDate: '',
      image,
      keywords: [570, 571, 572, 573, 574],
      mayStock: 0,
      showPrices: 1,
    },
  ],
  showCourseDialog = 0,
  defaultCourseId = randomId(2),
  portions = [
    {
      id: 1,
      name: 'Standard',
      portion_name: 'Standard',
      choices: [],
      price: randomPrice({ min: 1, max: 30 }),
    },
    {
      id: 2,
      name: 'Large',
      portion_name: 'Large',
      choices: [],
      price: randomPrice({ min: 1, max: 30 }),
    },
  ],
  categoryId = 1,
  subcategoryId = 1,
  divisionId = 1,
  calories = undefined,
} = {}) => {
  const payload = {
    itemType,
    selectedSalesAreas,
    sortOrder,
    itemId,
    productId,
    displayName,
    displayRecordId,
    defaultPortionId,
    choices,
    showPrices,
    mayStock,
    id,
    name,
    description,
    effectiveDate,
    expiryDate,
    image,
    keywords,
    eposName,
    displayRecords,
    showCourseDialog,
    defaultCourseId,
    portions,
    categoryId,
    subcategoryId,
    divisionId,
    calories,
  };
  return payload;
};

export const createMultipleMenuItems = (numberItems) => {
  const trueNumberItems = !numberItems
    ? 0
    : numberItems === 'random'
    ? randomNumber({ min: 3, max: 10 })
    : numberItems;
  return [...Array(trueNumberItems)].map((i, index) =>
    createMenuItem({ index }),
  );
};

export const createMultipleMenuProducts = (numberItems) => {
  const trueNumberItems = !numberItems
    ? 0
    : numberItems === 'random'
    ? randomNumber({ min: 3, max: 10 })
    : numberItems;
  return [...Array(trueNumberItems)].map((i, index) =>
    createMenuProduct({ index, calories: 50 }),
  );
};
